import { BaseService } from "../../services/_base-service";
import { Api, ApiResponse, StatusCode } from "../../utils/api";
import { ApiEndpoints } from "../../utils/app-constants";
import { VendorAddress } from "../models/vendor-address";

export class VendorSvc extends BaseService {

    public getVendorAddresses = async (vendorId : string) : Promise<ApiResponse<VendorAddress[]>> => {

        this._showLoading();
        const response = new ApiResponse<VendorAddress[]>();

        try {

            const aDetails = await Api.GetList(
                VendorAddress, 
                ApiEndpoints.VENDORS_ADDRESSES_BY_ID.formattify(vendorId)
            );

            if (aDetails) {
                response.data = aDetails;
                response.status = StatusCode.Success;
            }
            
        }
        catch (err) {
            response.status = this._handleError(err);
        }

        this._hideLoading();
        return response;
    }

}
